import Hero from "@/components/landing/Hero";
import Navbar from "@/components/landing/Navbar";
import PromoBanner from "@/components/landing/PromoBanner";
import GenuineParts from "@/components/landing/GenuineParts";
import SpinSection from "@/components/landing/SpinSection";
import RecentWinners from "@/components/landing/RecentWinners";
import CarePlusSection from "@/components/landing/CarePlusSection";
import Services from "@/components/landing/Services";
import Insurance from "@/components/landing/Insurance";
import CouponOffer from "@/components/landing/CouponOffer";
import CallbackForm from "@/components/landing/CallbackForm";
import WhyAutoHQ from "@/components/landing/WhyAutoHQ";
import Testimonials from "@/components/landing/Testimonials";
import Footer from "@/components/landing/Footer";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { waLink } from "@/lib/api";
import { trackWhatsappFloater } from "@/lib/pixel";

export default function Landing() {
  return (
    <div className="bg-white text-[#0A0A0A] min-h-screen text-left">
      <PromoBanner />
      <Navbar />
      <Hero />
      <GenuineParts />
      <CarePlusSection />
      <SpinSection />
      <RecentWinners />
      <Services />
      <Insurance />
      <CouponOffer />
      <CallbackForm />
      <WhyAutoHQ />
      <Testimonials />
      <Footer />

      {/* Sticky WhatsApp float */}
      <a
        data-testid="whatsapp-float-button"
        href={waLink("Hi AutoHQ! I'd like to know more about your services.")}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackWhatsappFloater}
        className="fixed bottom-4 right-4 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
        aria-label="Chat on WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16 .8C7.6.8.8 7.6.8 16c0 2.7.7 5.3 2 7.6L.8 31.2l7.8-2c2.2 1.2 4.7 1.9 7.4 1.9 8.4 0 15.2-6.8 15.2-15.2S24.4.8 16 .8zm0 27.7c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-4.6 1.2 1.2-4.5-.3-.5c-1.3-2-2-4.4-2-6.8C3.1 8.9 8.9 3.1 16 3.1S28.9 8.9 28.9 16 23.1 28.5 16 28.5zm7.1-9.4c-.4-.2-2.3-1.1-2.6-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.2 1.5-.2.2-.4.3-.8.1-.4-.2-1.6-.6-3.1-1.9-1.1-1-1.9-2.3-2.1-2.6-.2-.4 0-.6.2-.8.2-.2.4-.4.6-.7.2-.2.3-.4.4-.7.1-.3.1-.5 0-.7-.1-.2-.9-2.1-1.2-2.9-.3-.8-.6-.7-.9-.7h-.8c-.3 0-.7.1-1.1.5-.4.4-1.4 1.4-1.4 3.4s1.5 3.9 1.7 4.2c.2.3 2.9 4.5 7.1 6.3 1 .4 1.8.7 2.4.9 1 .3 1.9.3 2.6.2.8-.1 2.3-1 2.7-1.9.3-.9.3-1.7.2-1.9-.1-.2-.4-.3-.8-.5z" />
        </svg>
      </a>

      <ChatWidget />
    </div>
  );
}
